import { useState } from "react";

import { GetWSMgr } from "@/Utils/StateLib";
import { useTopic } from "@/hooks/useTopic";
import { Globals } from "@coreapp/CoreApp/Globals";

// Readiness gates the app chrome on user/permission state only, not doc existence
const computeReady = (): boolean => {
  const wsMgr = GetWSMgr();
  return (
    !!(Globals as unknown as { _loginComplete?: boolean })._loginComplete &&
    !!wsMgr?.fUserInfo &&
    !!wsMgr?.fAccessGroupMgr
  );
};

export const useAppReady = (): boolean => {
  const [ready, setReady] = useState<boolean>(computeReady);
  useTopic("LoginComplete", () => setReady(computeReady()));
  return ready;
};
